import { ItemViewModel } from '../viewModels/ItemViewModel';

export class FormLookupsBase {
    static populate<T>(items: T[], textPropertyName: string, valuePropertyName: string): ItemViewModel[] {
        return items.map((item: T) => new ItemViewModel((item as any)[textPropertyName], (item as any)[valuePropertyName]));
    }
}
